<template>
  <div class="base-pagination">
    <BasePagination
      :debug="debug"
      :value="current"
      :count="count"
      :page-size="perPage"
      @pageChange="pageChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    debug: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 50,
    },
    module: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  computed: {
    count() {
      return this.$store.state[this.module].count;
    },
  },
  methods: {
    pageChange(page) {
      this.$router.push(`/${this.path}/${page}`);

      window.scroll({
        top: 0,
        left: 0,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.base-pagination {
    margin: 1rem 0;
    display: flex;
    justify-content: center;
}
</style>
